// @ts-nocheck

import { cn } from '../../../utils/bem';

const Components = {};

Components[0] = require('./ContentBuilderTemplate0').default;
Components[1] = require('./ContentBuilderTemplate1').default;
Components[2] = require('./ContentBuilderTemplate2').default;
Components[3] = require('./ContentBuilderTemplate3').default;
Components[10] = require('./ContentBuilderTemplate10').default;
Components[13] = require('./ContentBuilderTemplate13').default;
Components[14] = require('./ContentBuilderTemplate14').default;
Components[16] = require('./ContentBuilderTemplate16').default;
Components[17] = require('./ContentBuilderTemplate17').default;
Components[18] = require('./ContentBuilderTemplate18').default;
Components[21] = require('./ContentBuilderTemplate21').default;
Components[24] = require('./ContentBuilderTemplate24').default;
Components[26] = require('./ContentBuilderTemplate26').default;
Components[27] = require('./ContentBuilderTemplate27').default;
Components[28] = require('./ContentBuilderTemplate28').default;
Components[29] = require('./ContentBuilderTemplate29').default;
Components[30] = require('./ContentBuilderTemplate30').default;
Components[31] = require('./ContentBuilderTemplate31').default;
Components[32] = require('./ContentBuilderTemplate32').default;
Components[33] = require('./ContentBuilderTemplate33').default;
Components[34] = require('./ContentBuilderTemplate34').default;
Components[35] = require('./ContentBuilderTemplate35').default;
Components[36] = require('./ContentBuilderTemplate36').default;
Components[37] = require('./ContentBuilderTemplate37').default;
Components[38] = require('./ContentBuilderTemplate38').default;
Components[39] = require('./ContentBuilderTemplate39').default;
Components[40] = require('./ContentBuilderTemplate40').default;
Components[41] = require('./ContentBuilderTemplate41').default;
Components[42] = require('./ContentBuilderTemplate42').default;
Components[43] = require('./ContentBuilderTemplate43').default;
Components[45] = require('./ContentBuilderTemplate45').default;
Components[46] = require('./ContentBuilderTemplate46').default;
Components[47] = require('./ContentBuilderTemplate47').default;
Components[48] = require('./ContentBuilderTemplate48').default;
Components[49] = require('./ContentBuilderTemplate49').default;
Components[50] = require('./ContentBuilderTemplate50').default;
Components[51] = require('./ContentBuilderTemplate51').default;
Components[52] = require('./ContentBuilderTemplate52').default;
Components[53] = require('./ContentBuilderTemplate53').default;
Components[54] = require('./ContentBuilderTemplate54').default;
Components[55] = require('./ContentBuilderTemplate55').default;
Components[56] = require('./ContentBuilderTemplate56').default;
Components[60] = require('./ContentBuilderTemplate60').default;
Components[61] = require('./ContentBuilderTemplate61').default;
Components[62] = require('./ContentBuilderTemplate62').default;
Components[63] = require('./ContentBuilderTemplate63').default;
Components[64] = require('./ContentBuilderTemplate64').default;
Components[65] = require('./ContentBuilderTemplate65').default;
Components[66] = require('./ContentBuilderTemplate66').default;
Components[67] = require('./ContentBuilderTemplate67').default;
Components[68] = require('./ContentBuilderTemplate68').default;
Components[69] = require('./ContentBuilderTemplate69').default;
Components[71] = require('./ContentBuilderTemplate71').default;
Components[72] = require('./ContentBuilderTemplate72').default;
Components[73] = require('./ContentBuilderTemplate73').default;
Components[74] = require('./ContentBuilderTemplate74').default;
Components[75] = require('./ContentBuilderTemplate75').default;
Components[76] = require('./ContentBuilderTemplate76').default;
Components[77] = require('./ContentBuilderTemplate77').default;
Components[78] = require('./ContentBuilderTemplate78').default;
Components[79] = require('./ContentBuilderTemplate79').default;
Components[80] = require('./ContentBuilderTemplate80').default;
Components[100] = require('./ContentBuilderTemplate100').default;
Components[102] = require('./ContentBuilderTemplate102').default;
Components[103] = require('./ContentBuilderTemplate103').default;
Components[104] = require('./ContentBuilderTemplate104').default;
Components[105] = require('./ContentBuilderTemplate105').default;
Components[107] = require('./ContentBuilderTemplate107').default;
Components[108] = require('./ContentBuilderTemplate108').default;
Components[109] = require('./ContentBuilderTemplate109').default;
Components[110] = require('./ContentBuilderTemplate110').default;
Components[111] = require('./ContentBuilderTemplate111').default;
Components[117] = require('./ContentBuilderTemplate117').default;
Components[122] = require('./ContentBuilderTemplate122').default;

export const cnContentBuilderTemplate = cn('ContentBuilderTemplate');

export default Components;
